module.exports = __webpack_public_path__ + "img/ArgCroacia2.530877a3.jpg";